export default __webpack_public_path__ + "static/media/iot posters.cbdcc1e2.webp";